var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customLoyaltyCardIcon)?_c('img',{staticStyle:{"width":"16px"},attrs:{"src":_vm.customLoyaltyCardIcon}}):_c('v-icon',{attrs:{"small":"","color":'black'}},[_vm._v(" mdi-credit-card-fast-outline ")])
}
var staticRenderFns = []

export { render, staticRenderFns }